export default "__VITE_ASSET__309c3e70__"